/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import client from '../apollo/apolloClient';
import ApolloQuickAnswers from '../apollo/apolloQuickAnswers';
import API from '../axios';

import { apiError } from '../observability/apiError';

export const getQuickAnswers = async (spaceId, descOrder) => {
  try {
    const { data } = await client.query({
      query: descOrder ? ApolloQuickAnswers.GET_QUICK_ANSWERS_ORDER_DESC : ApolloQuickAnswers.GET_QUICK_ANSWERS,
      variables: { spaceId },
    });
    return data.quickAnswers;
  } catch (error) {
    throw apiError('ERROR_GETTING_QUICK_ANSWERS', error, {
      operation: 'getQuickAnswers',
      module: 'utils/quickAnswers',
    });
  }
};

export const deleteQuickAnswer = async (quickAnswerId) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloQuickAnswers.DELETE_QUICK_ANSWER,
      variables: { quickAnswerId },
    });
    return data;
  } catch (error) {
    throw apiError('ERROR_DELETING_QUICK_ANSWER', error, {
      operation: 'deleteQuickAnswer',
      module: 'utils/quickAnswers',
    });
  }
};

export const createQuickAnswer = async (formData) => {
  try {
    const response = await API.post('/createQuickAnswer', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateQuickAnswer = async (formData) => {
  try {
    const response = await API.post('/updateQuickAnswer', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateQuickAnswerLastUse = async (quickAnswerId) => {
  try {
    const lastUse = moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
    const { data } = await client.mutate({
      mutation: ApolloQuickAnswers.UPDATE_QUICK_ASNWER_LAST_USER,
      variables: { quickAnswerId, lastUse },
    });
    return data.updateQuickAnswer;
  } catch (error) {
    throw error;
  }
};
